import React from 'react';
import { Table } from 'antd';
import scrollIntoView from 'scroll-into-view';

const Grid = ({ columnDefs, data }) => {
    const scrollToToday = () => {
        scrollIntoView(document.querySelector('.BRCellHighlight'), {
            align: {
                lockY: true,
            },
        });
    };
    scrollToToday();
    return (
        <div>
            <Table
                virtual
                columns={columnDefs}
                dataSource={data}
                scroll={{
                    x: 1300,
                }}
                size="small"
                pagination={false}
            />
        </div>
    );
};

export default Grid;
